import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * Multi-line counterpart to Input, same treatment (border-input, shadow-sm,
 * focus-visible ring). IssueDetailDialog in zafroi-project-management had a
 * hand-rolled <textarea> with these exact classes copied inline before this
 * existed — see docs/ui-ux-guidelines.md §9 (ADR-066): that's the pattern
 * this component exists to stop from recurring.
 */
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'flex min-h-[5rem] w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';

export { Textarea };
